// extracted by mini-css-extract-plugin
export default {"root":"root___KLL0V","header":"header___xRKia","block":"block___hW0z4"};